import React from 'react';

import styled from 'styled-components';

const Span = styled.span`
  margin-left: 4px;
  color: red;
`;

interface IProps {
  required?: boolean;
}

export default function RequiredMark({ required = true }: IProps): JSX.Element {
    return required ? <Span>*</Span> : <></>;
}

RequiredMark.defaultProps = {
    required: undefined,
};
